/**
 * Shared helpers for clinic portal user forms (providers, staff).
 */

export function generateUniqueStrongPassword() {
  const uuidHex = typeof crypto.randomUUID === 'function'
    ? crypto.randomUUID().replace(/-/g, '')
    : Array.from(crypto.getRandomValues(new Uint8Array(16)))
      .map((b) => b.toString(16).padStart(2, '0'))
      .join('');

  const lower = 'abcdefghijklmnopqrstuvwxyz';
  const upper = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  const digits = '0123456789';
  const symbols = '!@#$%^&*';
  const all = lower + upper + digits + symbols;
  const buf = new Uint8Array(20);
  crypto.getRandomValues(buf);
  const out = [];
  out.push(lower[buf[0] % lower.length]);
  out.push(upper[buf[1] % upper.length]);
  out.push(digits[buf[2] % digits.length]);
  out.push(symbols[buf[3] % symbols.length]);
  for (let i = 4; i < 20; i += 1) {
    out.push(all[buf[i] % all.length]);
  }
  return uuidHex + out.join('');
}

/** API returns string[]; tolerate legacy string. */
export function normalizeTags(v) {
  if (Array.isArray(v)) {
    return v.map((x) => String(x).trim()).filter(Boolean);
  }
  if (typeof v === 'string' && v.trim()) {
    const s = v.trim();
    if (s.startsWith('[')) {
      try {
        const p = JSON.parse(s);
        if (Array.isArray(p)) return p.map((x) => String(x).trim()).filter(Boolean);
      } catch {
        return [s];
      }
    }
    return [s];
  }
  return [];
}

/**
 * Each word: title case. Words of 1–3 letters that are only letters are uppercased (e.g. md → MD).
 */
export function formatTagTitleCase(raw) {
  const s = String(raw).trim();
  if (!s) return '';
  return s
    .split(/\s+/)
    .map((word) => {
      if (!word) return '';
      if (word.length <= 3 && /^[a-zA-Z]+$/.test(word)) {
        return word.toUpperCase();
      }
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    })
    .join(' ')
    .trim();
}
